const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function defaultNewAlbumTitle() {
  const now = new Date();

  return `Uploaded on ${monthNames[now.getMonth()]} ${now.getDate()}, ${now.getFullYear()}`;
}
